/**
 * Impressum (legal notice) page generator
 */
import { esc } from '@/utils/escape';

export function generateImpressumHTML(settings: any): string {
  const legal = settings.companyLegal || {};
  return `<!DOCTYPE html>
<html lang="de"${settings.darkMode ? ' class="dark"' : ''}>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Impressum \u2013 ${esc(settings.siteName)}</title>
  <link rel="stylesheet" href="css/tokens.css">
  <link rel="stylesheet" href="css/components.css">
</head>
<body>
  <main class="legal-page">
    <div class="container">
      <h1>Impressum</h1>

      <h2>Angaben gem\u00e4ss Schweizer Recht</h2>
      <p>
        <strong>${esc(legal.name)}</strong><br>
        ${esc(legal.address)}<br>
        ${legal.uid ? `UID: ${esc(legal.uid)}<br>` : ''}
      </p>

      <h2>Kontakt</h2>
      <p>
        Telefon: ${esc(legal.phone)}<br>
        E-Mail: ${esc(legal.email)}
      </p>

      <h2>Vertretungsberechtigte Person</h2>
      <p>${esc(legal.owner)}</p>

      <h2>Haftungsausschluss</h2>
      <p>Der Autor \u00fcbernimmt keine Gew\u00e4hr f\u00fcr die Richtigkeit, Genauigkeit, Aktualit\u00e4t, Zuverl\u00e4ssigkeit und Vollst\u00e4ndigkeit der Informationen.</p>

      <p><a href="index.html">\u2190 Zur\u00fcck zur Startseite</a></p>
    </div>
  </main>
  <script src="js/main.js"><${'/'}script>
</body>
</html>`;
}
